class ModelViewer {
  public element: HTMLElement | null;
  public viewer: any | null | undefined;
  public buttonOpen: HTMLElement | null | undefined;
  public buttonClose: HTMLElement | null | undefined;
  public scrollPos: number;

  bindings() {
    if (this.buttonOpen) {
      this.buttonOpen.addEventListener('click', () => {
        this.element?.classList.add('active');

        this.scrollPos = window.scrollY;

        window.scrollTo({
          top: this.viewer?.getBoundingClientRect().top ? this.viewer?.getBoundingClientRect().top + window.scrollY : window.scrollY,
          left: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          document.body.style.width = '100%';
          document.body.style.top = `-${this.viewer?.getBoundingClientRect().top ? this.viewer?.getBoundingClientRect().top + window.scrollY : window.scrollY}px`;
          document.body.style.overflowY = 'scroll';
          document.body.style.position = 'fixed';
        }, 500);
      });
    }

    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', () => {
        this.element?.classList.remove('active');

        document.body.removeAttribute('style');

        window.scrollTo({
          top: this.scrollPos,
          left: 0,
          // @ts-ignore
          behavior: 'instant',
        });
      });
    }

    if (this.viewer?.dataset.scale) {
      this.viewer.addEventListener('load', () => {
        if (this.viewer && this.viewer.dataset.scale) {
          this.viewer.scale = `${this.viewer?.dataset.scale} ${this.viewer?.dataset.scale} ${this.viewer?.dataset.scale}`;
        }
      });
    }
  }

  cache() {
    this.element = document.querySelector('.o-model-viewer');
    this.viewer = this.element?.querySelector('model-viewer');
    this.buttonOpen = this.element?.querySelector('.js-button-open');
    this.buttonClose = this.element?.querySelector('.js-button-exit');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ModelViewer;
